<div class="flex min-h-screen flex-col">
  <div class="bg-white py-12 sm:py-12 flex flex-row justify-center items-center">
    <div class="mx-auto max-w-4xl px-6 max-lg:text-center lg:max-w-7xl lg:px-8 flex flex-col items-center">
      <img class="mx-auto h-16 w-auto" src="assets/shout_logo_blue.png" alt="SHOUT">
      <p
        class="mt-4 max-w-2xl text-pretty mx-auto t text-lg font-medium text-gray-600 max-lg:mx-auto sm:text-xl/8">
        Select a platform
      </p>
      @if (authentiationMode == 'authentic') {
        <i class="mx-auto text-gray-500 text-xs italic">Authentic</i>
      }
    </div>

  </div>

  <div class="relative isolate overflow-hidden bg-white">

    <div class="mx-auto px-6 pb-12 lg:flex lg:px-8">

      <div
        class="w-full rounded-2xl ring-1 ring-inset ring-black/5 bg-[linear-gradient(115deg,var(--tw-gradient-stops))] from-[#4338CA] from-[28%] via-[#b060ff] via-[70%] to-[#ee87cb] sm:rounded-3xl shadow-lg">

        <div class="relative isolate">

          <div class="mx-auto max-w-7xl px-6 py-4 sm:py-4 lg:flex lg:items-center lg:gap-x-4 lg:px-4 lg:py-4">
            <div class="mx-auto max-w-7xl flex flex-col lg:flex-row gap-y-6 lg:gap-x-6">

              <div (click)="selectPlatform(platforms[0].action)"
                   class="col-span-1 rounded-xl bg-white/30 px-2 py-2 ring-inset cursor-pointer items-center ring-white ring-2 shadow-lg flex flex-row">
                <div
                  class="flex w-12 shrink-0 items-center justify-center rounded-l-md text-sm font-medium text-white">
                  <img class="mx-auto size-12" [src]="platforms[0].icon" alt="">
                </div>
                <div class="flex flex-1 items-center justify-between truncate">
                  <div class="flex-1 truncate px-2 py-2 text-sm">
                    <a class="text-lg font-medium text-white">TikTok</a>
                    @if (hasPlatformConnected(platforms[0])) {
                      <p class="text-gray-200">{{
                          getPlatformHandle(platforms[0])
                        }}</p>
                    } @else {
                      <p class="text-gray-200">Connect</p>
                    }
                  </div>
                  <div class="shrink-0 flex items-center">
                    @if (currentConnections?.tiktok?.source === TikTokValuesSourceEnum.TIKTOK_API) {
                      <button type="button"
                              class="relative inline-flex size-8 items-center justify-center rounded-full text-green-400">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                             fill="currentColor" class="size-8">
                          <path fill-rule="evenodd"
                                d="M12.516 2.17a.75.75 0 0 0-1.032 0 11.209 11.209 0 0 1-7.877 3.08.75.75 0 0 0-.722.515A12.74 12.74 0 0 0 2.25 9.75c0 5.942 4.064 10.933 9.563 12.348a.749.749 0 0 0 .374 0c5.499-1.415 9.563-6.406 9.563-12.348 0-1.39-.223-2.73-.635-3.985a.75.75 0 0 0-.722-.516l-.143.001c-2.996 0-5.717-1.17-7.734-3.08Zm3.094 8.016a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z"
                                clip-rule="evenodd"/>
                        </svg>
                      </button>
                    } @else if (currentConnections?.tiktok?.source ===
                    TikTokValuesSourceEnum.TIK_API && authentiationMode === 'authentic') {
                      <span
                        class="relative inline-flex items-center gap-x-1.5 rounded-full px-2 py-1 text-xs font-medium text-white ring-1 ring-inset ring-white">
                                            <svg viewBox="0 0 6 6" aria-hidden="true"
                                                 class="size-1.5 fill-green-500 dark:fill-green-400">
                                                <circle r="3" cx="3" cy="3"/>
                                            </svg>
                                            Upgrade
                                        </span>
                    } @else {
                      <button type="button"
                              class="inline-flex size-8 items-center justify-center rounded-full text-white">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                             stroke-width="1.5" stroke="currentColor" class="size-6">
                          <path stroke-linecap="round" stroke-linejoin="round"
                                d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3"/>
                        </svg>
                      </button>
                    }
                  </div>
                </div>
              </div>

              <div (click)="selectPlatform(platforms[1].action)"
                   class="col-span-1 rounded-xl bg-white/30 px-2 py-2 ring-inset cursor-pointer items-center ring-white ring-2 shadow-lg flex flex-row">
                <div
                  class="flex w-12 shrink-0 items-center justify-center rounded-l-md text-sm font-medium text-white">
                  <img class="mx-auto size-12" [src]="platforms[1].icon" alt="">
                </div>
                <div class="flex flex-1 items-center justify-between truncate">
                  <div class="flex-1 truncate px-2 py-2 text-sm">
                    <a class="text-lg font-medium text-white">Instagram</a>
                    @if (hasPlatformConnected(platforms[1])) {
                      <p class="text-gray-200">{{
                          getPlatformHandle(platforms[1])
                        }}</p>
                    } @else {
                      <p class="text-gray-200">Connect</p>
                    }
                  </div>
                  <div class="shrink-0 flex items-center">
                    <button type="button"
                            class="relative inline-flex size-8 items-center justify-center rounded-full text-white">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                           stroke-width="1.5" stroke="currentColor" class="size-6">
                        <path stroke-linecap="round" stroke-linejoin="round"
                              d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3"/>
                      </svg>
                    </button>
                  </div>
                </div>
              </div>


<!--              <div (click)="selectPlatform(platforms[3].action)"-->
<!--                   class="col-span-1 rounded-xl bg-white/30 px-2 py-2 ring-inset cursor-pointer items-center ring-white ring-2 shadow-lg flex flex-row">-->
<!--                <div-->
<!--                  class="flex w-12 shrink-0 items-center justify-center rounded-l-md text-sm font-medium text-white">-->
<!--                  <img class="mx-auto size-12" [src]="platforms[3].icon" alt="Platform logo">-->
<!--                </div>-->
<!--                <div class="flex flex-1 items-center justify-between truncate">-->
<!--                  <div class="flex-1 truncate px-2 py-2 text-sm">-->
<!--                    <a class="text-lg font-medium text-white">YouTube</a>-->
<!--                    @if (hasPlatformConnected(platforms[3])) {-->
<!--                      <p class="text-gray-200">{{-->
<!--                          getPlatformHandle(platforms[3])-->
<!--                        }}</p>-->
<!--                    } @else {-->
<!--                      <p class="text-gray-200">Connect</p>-->
<!--                    }-->
<!--                  </div>-->
<!--                  <div class="shrink-0 flex items-center">-->
<!--                    <button type="button"-->
<!--                            class="relative inline-flex size-8 items-center justify-center rounded-full text-white">-->
<!--                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"-->
<!--                           stroke-width="1.5" stroke="currentColor" class="size-6">-->
<!--                        <path stroke-linecap="round" stroke-linejoin="round"-->
<!--                              d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3"/>-->
<!--                      </svg>-->
<!--                    </button>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->


            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Safety Disclaimer -->
  <div class="lg:max-w-lg mx-auto px-6 pb-12">
    <p class="mt-2 text-2xl font-semibold tracking-tight text-pretty text-gray-900 sm:text-3xl">
      Connected Accounts</p>
    <p class="mt-6 text-sm text-gray-700">We connect social accounts using official TikTok, Instagram and YouTube services.
      SHOUT has been reviewed and approved by all listed platforms.
    </p>
    <dl class="mt-10 max-w-xl space-y-8 text-base/7 text-gray-600 lg:max-w-none">
      <div class="relative pl-9">
        <dt class="inline font-semibold text-gray-900">
          <svg class="absolute top-1 left-1 size-5 text-indigo-600" xmlns="http://www.w3.org/2000/svg"
               viewBox="0 0 24 24" fill="currentColor">
            <path fill-rule="evenodd"
                  d="M12.516 2.17a.75.75 0 0 0-1.032 0 11.209 11.209 0 0 1-7.877 3.08.75.75 0 0 0-.722.515A12.74 12.74 0 0 0 2.25 9.75c0 5.942 4.064 10.933 9.563 12.348a.749.749 0 0 0 .374 0c5.499-1.415 9.563-6.406 9.563-12.348 0-1.39-.223-2.73-.635-3.985a.75.75 0 0 0-.722-.516l-.143.001c-2.996 0-5.717-1.17-7.734-3.08Zm3.094 8.016a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z"
                  clip-rule="evenodd"/>
          </svg>
          Consent matters.
        </dt>
        <dd class="inline text-sm">We only fetch data that you have consented to share.</dd>
      </div>
      <div class="relative pl-9">
        <dt class="inline font-semibold text-gray-900">
          <svg class="absolute top-1 left-1 size-5 text-indigo-600" viewBox="0 0 20 20" fill="currentColor"
               aria-hidden="true" data-slot="icon">
            <path fill-rule="evenodd"
                  d="M10 1a4.5 4.5 0 0 0-4.5 4.5V9H5a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2h-.5V5.5A4.5 4.5 0 0 0 10 1Zm3 8V5.5a3 3 0 1 0-6 0V9h6Z"
                  clip-rule="evenodd"/>
          </svg>
          Safety & Security.
        </dt>
        <dd class="inline text-sm">We use industry-standard encryption & best practices to protect your data.
        </dd>
      </div>
      <div class="relative pl-9">
        <dt (click)="incrementToggleCount()" class="inline font-semibold text-gray-900">
          <svg class="absolute top-1 left-1 size-5 text-indigo-600" xmlns="http://www.w3.org/2000/svg"
               viewBox="0 0 24 24" fill="currentColor">
            <path
              d="m11.645 20.91-.007-.003-.022-.012a15.247 15.247 0 0 1-.383-.218 25.18 25.18 0 0 1-4.244-3.17C4.688 15.36 2.25 12.174 2.25 8.25 2.25 5.322 4.714 3 7.688 3A5.5 5.5 0 0 1 12 5.052 5.5 5.5 0 0 1 16.313 3c2.973 0 5.437 2.322 5.437 5.25 0 3.925-2.438 7.111-4.739 9.256a25.175 25.175 0 0 1-4.244 3.17 15.247 15.247 0 0 1-.383.219l-.022.012-.007.004-.003.001a.752.752 0 0 1-.704 0l-.003-.001Z"/>
          </svg>
          Trust.
        </dt>
        <dd class="inline text-sm">Meta & TikTok have reviewed and approved SHOUT as a safe and secure
          way to connect your social accounts.
        </dd>
      </div>
    </dl>

    <p class="mt-6 text-xs text-gray-700 mx-auto text-center">By connecting your social accounts, you agree to our
      <a href="https://shoutugc.com/terms-of-service" class="text-indigo-600">Terms of Service</a> and <a
        href="https://shoutugc.com/privacy-policy" class="text-indigo-600">Privacy Policy</a>.
    </p>
    <p class="mt-6 text-xs text-gray-700 mx-auto text-center">v0.3.0</p>

    @if (showToggle) {
      <div class="mt-6 w-full flex flex-row justify-center items-center">
        <nav aria-label="Tabs" class="flex space-x-4">
          <a (click)="authentiationMode = 'authentic'"
             class="rounded-md px-3 py-2 text-sm font-medium hover:cursor-pointer"
             [class]="getAuthenticationModeClass('authentic')">Authentic</a>
          <a (click)="authentiationMode = 'manual'"
             class="rounded-md px-3 py-2 text-sm font-medium hover:cursor-pointer"
             [class]="getAuthenticationModeClass('manual')">Manual</a>
        </nav>
      </div>
    }


  </div>
  <!-- Safety Disclaimer END -->

  @if (alreadyConnectedError) {
    <alert-already-connected [platform]="alreadyConnectedError"
                             (close)="alreadyConnectedError = undefined"></alert-already-connected>
  }
</div>
